<script>
import { RouterLink } from "vue-router";

import { useSearchRoute } from "@/common/composables/use-search-route";

export default {
  name: "ContentsWithLinks",
  components: {
    RouterLink
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    textClass: {
      type: [String, Array, Object],
      default: undefined
    },
    linkClass: {
      type: [String, Array, Object],
      default: undefined
    }
  },
  computed: {
    type() {
      return this.content.type;
    },
    text() {
      return this.content.text;
    },
    textLink() {
      return this.content?.textLink;
    }
  },
  methods: {
    getSearchRoute(searchWord) {
      return useSearchRoute(this.$router).getSearchRoute(searchWord);
    }
  }
};
</script>

<template>
  <span>
    <slot name="before" />
    <span v-if="type === 'text'" :class="textClass" v-html="text"></span>
    <RouterLink v-if="type === 'link'" :class="linkClass" :to="getSearchRoute(textLink)"
      ><span v-html="text"></span
    ></RouterLink>
  </span>
</template>
